import { render, staticRenderFns } from "./data-panel.vue?vue&type=template&id=b8ffe9fa&scoped=true"
import script from "./data-panel.vue?vue&type=script&lang=js"
export * from "./data-panel.vue?vue&type=script&lang=js"
import style0 from "./data-panel.vue?vue&type=style&index=0&id=b8ffe9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ffe9fa",
  null
  
)

export default component.exports